import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Zap } from 'lucide-react';

interface LoadingFallbackProps {
  message?: string;
  showLogo?: boolean;
}

export function LoadingFallback({ 
  message = "Loading...", 
  showLogo = true 
}: LoadingFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-6">
          {showLogo && (
            <div className="flex justify-center mb-6">
              <div className="p-3 bg-primary/10 rounded-full">
                <Zap className="h-8 w-8 text-primary animate-pulse" />
              </div>
            </div>
          )}
          
          <div className="space-y-4">
            <div className="text-center">
              <h3 className="font-semibold text-lg">ChargeShare</h3>
              <p className="text-sm text-muted-foreground">{message}</p>
            </div>
            
            <div className="space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4 mx-auto" />
              <Skeleton className="h-4 w-1/2 mx-auto" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default LoadingFallback;